import React, { useState, useRef, useEffect } from "react";
import Menu from "@material-ui/core/Menu";
import Edit from "../../../assets/images/edit.svg";
import PinLocation from "../../../assets/images/pin.svg";
import { useSelector, useDispatch } from "react-redux";
import Popup from "../../popup/popup";
import { FaFileUpload } from "react-icons/fa";
import PlusIcon from "../../../assets/images/plusIconSquare.svg";
import JoditEditor from "jodit-react";
// import ImageMultiSelect from "../../../components/holidays/listings/imageMultiSelect/imageMultiSelect";
import ImageMultiSelect from "../../../common/imageMultiSelect/imageMultiSelect";
import GoogleMapModal from "../../utilities/GoogleMap/MapModal";
import Button from "@material-ui/core/Button";
import MenuItem from "@material-ui/core/MenuItem";
import ArrowDown from "../../../assets/images/arrowDown.svg";
import { withStyles } from "@material-ui/core/styles";
import Switch from "@material-ui/core/Switch";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import DefaultImage from "../../../assets/images/plain-background.jpeg";
import "../../../assets/css/partials/addCorpPackageDetails.scss";
import "../../../assets/css/partials/packageDetails.scss";
import "../../../assets/css/partials/layout.scss";
import * as holidayListingAction from "../../../actions/holidaysAction";
import * as bookingAction from "../../../actions/bookingAction";
import { getHolidaySectionList } from '../../../actions/holidaySectionAction';
import { useSnackbar } from "notistack";
import LinearProgress from '@material-ui/core/LinearProgress';
import Input from "../../../common/uiElements/input";
import { Tabs } from "antd";
import { ACTIVITY_LEVEL_VALUE, checkFeaturedAmenitiesLength, focusInput, scheduleDaysVal, scheduleNightsVal } from '../../../utils/index';
import ToggleButton from '../../holidays/listings/toggle';
import OpeningSoonCalander from "./openingSoonCalander";
import moment from 'moment';
import Autocomplete from "../../../common/autoComplete";
import { countryList } from '../../../common/countryList';
import FeaturedPackage from "../../../common/featuredPackage";
import Dropdown from "../../../common/uiElements/dropdown";
import Error from "../../../common/error";
import ToggleGroup from "../../../common/uiElements/toggelGroup";
import MinMaxInput from "../../../common/uiElements/minMaxInput";
import ScheduleBoxItinerary from "./scheduleBoxItinerary";
import PackTypeButtons from "../../../common/uiElements/packTypeButtons";
import CkEditor from '../../../common/ckEditor/ckeditor'
import BlockDatePopup from "../../popup/blockDatePopup";
import Meta_Input from "../../../common/uiElements/meta_Input";
import AddHandleRate from "../../../common/addRateModel";
import StructureData from "../../../common/structureData";
import ItinraryBoxField from "../../../common/itinararyBox";
// import { getCroppedFile } from "../../utilities/ImageCropper/utils";


import {
  SECTION_NAME,
  PACKAGE_TITLE_EMPTY_ERROR_VALIDATION,
  PACKAGE_TITLE_LENGTH_ERROR_VALIDATION,
  IMAGE,
  LOCATION_EMPTY,
  LOCATION_EMPTY_LENGTH,
  PRICE,
  PRICE_LENGTH,
  SCHEDULE,
  BRIEF_DESCRIPTION_EMPTY,
  BRIEF_DESCRIPTION_EMPTY_LENGTH,
  VALID_TILL,
  DESCRIPTION,
  THUMBNAIL_IMAGE_ERROR,
  REVISED_PRICE,
  REVISED_PRICE_LENGTH,
  GUEST_EMPTY,
  LOCATION_TYPE_EMPTY,
  ACTIVITY_TYPE_EMPTY,
  ACTIVITY_LEVEL_EMPTY,
  AGES_EMPTY,
  ITINERARY_EMPTY,
  ACCOMODATION_EMPTY,
  ESSENTIAL_INFO_EMPTY,
  FAQ,
  REVISED_PRICE_ERROR,
  GUEST_ERROR,
  LOCATION_TYPE_CHAR_LIMIT,
  FEATURED_AMENITIES_ERROR,
  COUNTRY_ERROR,
  CITY_ERROR
} from '../../../utils/constants';
import {FEATURED_AMENITIES_LIST, ROOM_AMENITIES_LIST, ACTIVITY_OPTIONS, ACTIVITY_LEVEL_OPTIONS, RESORT_FACILITIES_LIST} from '../../../resources/packageData'
import { ContactSupportOutlined } from "@material-ui/icons";
import SecondLocation from "../../../common/secondLocation";
//


const { TabPane } = Tabs;
const PurpleSwitch = withStyles({
  switchBase: {
    color: "white",
    "&$checked": {
      color: "#2196F3",
    },
    "&$checked + $track": {
      backgroundColor: "#2196F3",
      opacity: 1,
    },
  },
  checked: {},
  track: {},
})(Switch);

export default function AddHolidayPackageDetails() {
  const [imageSelect, setImageSelect] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const [locationSelect, setLocationSelect] = useState(false);
  const[addHandleRate,setAddHandleRate]=useState(false)
  const [isLoading, setIsLoading] = useState(false);
  const [popupSelect, setPopupSelect] = useState(false);
  const [content, setContent] = useState("");
  const [select, setSelect] = React.useState(null);
  const [blockDates_Range,setBlockDates_range]=useState()
  const [popupDateBlock,setPopupDateBLock]=useState(false)
  const[block_date_range,setBlock_date_range]=useState()
  const [isEdit, setIsEdit] = useState(false);
  const [isGiftVoucher, setIsGiftVoucher] = useState(false);
  const [dropdownValue, setDropdownValue] = useState(null);
  const [isFeaturedErrorValidation, setIsFeaturedErrorValidation] = useState("");
  const [isCorpAddSecnameErrorValidation, setIsCorpAddSecnameErrorValidation] = useState(null);
  const [isCorpAddPackTitleEmptyErrorValidation, setIsCorpAddPackTitleEmptyErrorValidation] = useState(null);
  const [isCorpAddPackTitleLengthErrorValidation, setIsCorpAddPackTitleLengthErrorValidation] = useState(null);
  const[isSlug,setIsSlug]=useState(null)
  const [isCorpAddImgErrorValidation, setIsCorpAddImgErrorValidation] = useState(null);
  const [isCorpAddImgThumbnailErrorValidation, setIsCorpAddImgThumbnailErrorValidation] = useState(null);
  const [isCorpAddPointsEmptyErrorValidation, setIsCorpAddPointsEmptyErrorValidation] = useState(null);
  const [isCorpAddPointsLengthErrorValidation, setIsCorpAddPointsLengthErrorValidation] = useState(null);
  const [iscorpAddBrigDescEmtyErrorValidation, setIscorpAddBrigDescEmtyErrorValidation] = useState(null);
  const [iscorpAddBrigDescLengthErrorValidation, setIscorpAddBrigDescLengthErrorValidation] = useState(null);
  const [iscoprAddLocationEmptyErrorvalidation, setIscoprAddLocationEmptyErrorvalidation] = useState(null);
  const [iscoprAddLocationLengthErrorvalidation, setIscoprAddLocationLengthErrorvalidation] = useState(null);
  const [iscorpAddScheduleErrorValidation, setIscorpAddScheduleErrorValidation] = useState(null);
  const [iscorpAddValidTillErrorValidation, setIscorpAddValidTillErrorValidation] = useState(null);
  const [iscorpAddDesErrorValidation, setIscorpAddDesErrorValidation] = useState(null);
  const [symbolValidation,setSymbolValidation]=useState(false);
  const[symbolErrorMsg,setSymbolErrorMsg]=useState()
  const[revisePrice,setRevisedPrice]=useState()
  const [countryError, setCountryError] = useState(null);
  const [isError, setIsError] = useState({ error: false, msg: "", name: "" })
  const [openingSoon, setOpeningSoon] = useState(false);
  const [dateValue, setDateValue] = useState(null);
  const [scheduleType, setScheduleType] = useState(null);
  const [dateRangeDate, setDateRangeDate] = useState(null);
  const [value, setValue] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [locationCityValue, setLocationCityValue] = useState(null);
  const getLocationdropDownList = useSelector((state) => state.holidayListing.dropDownLocationlist);
  const holidayListingDropDownVal = useSelector((state) => state.holidayListing.holidayListingDropDownvalue);
  const pageID = useSelector((state) => state.holidayListing.pageId);
  const openingSoonVal = useSelector((state) => state.holidayListing.openingSoonValue);
  const addImage = useSelector((state) => state.holidayListing.allImagesHolidayData);
  const selectedMenuDropdown = useSelector((state) => state.holidaySection?.getHolidaySectionList);
  const [structureData,setStructureData]=useState()
  const imageThubnail = addImage.find((img) => img.thumbnail === true);
  const dispatch = useDispatch();
  const imagesWithoutId = addImage;
  const editor = useRef(null);
  const [priceList, setPriceList] = useState({
    adults: [{adult1:null}],
    children: [{child1:null}]
  });



  const handleAddPrice = () => {
    
    const allValuesUpdated = Object.values(priceList).every(categoryArray =>
      categoryArray.every(item =>
        Object.values(item).every(value => {
          const isValid = value !== null && !isNaN(value);
          return isValid;
        })
      )
    );
    

  
    if (!allValuesUpdated) {
      enqueueSnackbar("Please fill all the fields", {
        variant: "error",
      });
    } else {
      setIsError({error: false, name: "discounted_rate", msg: "Please add atleast oneadult and one child disounted rate"})
      setRevisedPrice(priceList?.adults[0].adult1)
      setAddHandleRate(false);
    }
  };
  

  let filteredDropDownList = selectedMenuDropdown && selectedMenuDropdown.
    filter(item => item.name !== "Visas & More" && item.name !== "Customize" && item.name !== "Send a Gift");

  let CityAndCountryLabel = `${dropdownValue?.name === "International" ? "Select Country" : "City of Location"} `

  const handleClickSelect = (event) => {
    dispatch(getHolidaySectionList());
    setSelect(event.currentTarget);
  };

  const handleCloseSelect = (item) => {
    setDropdownValue(item);
    setSelect(null);
    setIsCorpAddSecnameErrorValidation(false) 
  };

  const [state, setState] = useState({
    package_type: "staybased",
    pack_title: "",
    slug:"",
    meta_title:"",
    meta_description:"",
    brief_description: "null",
    edenred_product_code:"",
    note: null,
    images: [],
    location: [],
    disable_tomorrows_bookings:false,
    restricted_booking_dates:null,
    schedule_type: "",
    schedule_data: {},
    valid_till: "",
    price: "",
    best_seller: false,
    deal: false,
    covid_safe: false,
    opening_soon: null,
    description: "",
    location_city: "",
    featured: false,
    location_country: "",
    flexi_schedule: false,
    enable_payment: false,
    revised_price: "",
    location_type: "",
    group_size: {min: "", max: ""},
    ages: "",
    activity_type: "",
    activity_level: "",
    itinerary: "",
    accomodations: "",
    essential_info: "",
    faq: "",
    featured_amenities: JSON.parse(JSON.stringify(FEATURED_AMENITIES_LIST)),
    room_amenities: JSON.parse(JSON.stringify(ROOM_AMENITIES_LIST)),
    hotel_resort_facilities: JSON.parse(JSON.stringify(RESORT_FACILITIES_LIST))
  });
 

  const location = [
    {
      address: "12th A Main Rd",
      latitude: "12.96973150000000",
      longitude: "77.63991412753906",
      city: "Bengaluru",
      state: "Karnataka",
      location: "SRID=4326;POINT (77.63991412753906 12.9697315)",
      active: true,
      created: "2021-08-24T15:41:28.706508",
      location: "SRID=4326;POINT (77.63776836032714 12.9697315)",
      modified: "2021-08-24T15:41:28.706524",
    }
  ];
  const handleChange = (key, value) => {
    setState(() => ({
      ...state,
      [key]: value.target.value,
    }));
    
    setIsError({ error:false, msg:'', name: "" })
    setIsCorpAddPackTitleEmptyErrorValidation(false)
    setIsCorpAddPackTitleLengthErrorValidation(false)
    if(state?.slug?.length>0){
      setIsSlug(false)
    }
  };

  const meta_title_change=(key, value)=>{
    setState(() => ({
      ...state,
      [key]: value.target.value,
    }));
    setIsError({ error:false, msg:'', name: "" })
    setIsCorpAddPackTitleEmptyErrorValidation(false)
    setIsCorpAddPackTitleLengthErrorValidation(false)

  }

  const handleBlockTommorow=(event)=>{
    
    if (event.target.checked === true) {
   
   setState({
    ...state,
    disable_tomorrows_bookings: true
   })
  }
else{

 setState({
  ...state,
  disable_tomorrows_bookings: false
 })

}
  }
  const meta_description=(key, value)=>{
    setState(() => ({
      ...state,
      [key]: value.target.value,
    }));
    setIsError({ error:false, msg:'', name: "" })
    setIsCorpAddPackTitleEmptyErrorValidation(false)
    setIsCorpAddPackTitleLengthErrorValidation(false)

  }
  const priceHandler = (key, e) => {
    setState(() => ({
      ...state,
      [key]: e.target.value,
    }));
    setIsError({ error:false, msg:'', name: "" })
    setIsCorpAddPointsEmptyErrorValidation(false)
    setIsCorpAddPointsLengthErrorValidation(false)
  };

  const briefDescriptionHandler = (key, value) => {
    setState(() => ({
      ...state,
      [key]: value.target.value,
    }));
    setIscorpAddBrigDescEmtyErrorValidation(false)
    setIscorpAddBrigDescLengthErrorValidation(false)
  };
  const handleError = (errorMsg) => {
    setIsFeaturedErrorValidation(errorMsg);
  }
  const validTillHandler = (key, value) => {
    setState(() => ({
      ...state,
      [key]: value.target.value,
    }));
    setIscorpAddValidTillErrorValidation(false)
  };
  const loader = (id) => {
    dispatch(holidayListingAction.getHolidayList(pageID, holidayListingDropDownVal?.id));
    dispatch(holidayListingAction.editHolidayListItem(id));
    setIsLoading(false)
  };
  const dateSheduleHandler = (key, value) => {
    setState(() => ({
      ...state,
      [key]: value.target.value,
    }));
    setIscorpAddScheduleErrorValidation(false)
  };
  function checkSentence(title) {
    const allowedRegex = /[@#*()\-\_,]/;
    const notAllowedRegex = /[~`!$%^&+=\{\}\[\]|\\/:;"‘<>.?]/;

    for (let i = 0; i < title.length; i++) {
        const char = title.charAt(i);
     if (notAllowedRegex.test(char)) {
      setSymbolValidation(true)
      setSymbolErrorMsg(`${char} -> now allowed in title please remove !`)
    
      enqueueSnackbar(`${char} -> now allowed in title please remove !`, {
        variant: "error",
    });

           return 
        } 
        else{
          setSymbolValidation(false)
          setSymbolErrorMsg(false)

        }
    }
}

  const newDataSubmithandler = (e) => {
    e.preventDefault();
    checkSentence(state.pack_title)
   
    setIsCorpAddSecnameErrorValidation(false);
    setIsCorpAddPackTitleEmptyErrorValidation(false);
    setIsCorpAddPackTitleLengthErrorValidation(false);
    setIsCorpAddImgErrorValidation(false);
    setIsCorpAddImgThumbnailErrorValidation(false);
    setIsCorpAddPointsEmptyErrorValidation(false);
    setIsCorpAddPointsLengthErrorValidation(false);
    setIscorpAddBrigDescEmtyErrorValidation(false);
    setIscorpAddBrigDescLengthErrorValidation(false);
    setIscoprAddLocationEmptyErrorvalidation(false);
    setIscoprAddLocationLengthErrorvalidation(false);
    setIscorpAddScheduleErrorValidation(false);
    setIscorpAddValidTillErrorValidation(false);
    setIscorpAddDesErrorValidation(false);
    setCountryError(false)
    let finalImages = addImage.map((item, index) => {

      let sImg = {
        image: item.image,
        video: item.video || '',
        thumbnail: item.thumbnail,
        priority: index + 1,
        media_type: item.media_type,
        alt_text:item.alt_txt||"",
        title_text:item.title_txt||""
      };

      return sImg;

    });

    const addNewData = {
      section: dropdownValue?.id,
      package_type: state.package_type,
      pack_title: state.pack_title.trim().replace(/\s+/g, ' '),
      slug:state.slug,
      meta_info : {"meta_title":state.meta_title,
      "meta_description":state.meta_description
      },
      edenred_product_code:state?.edenred_product_code,
      brief_description: state.brief_description,
      disable_tomorrows_bookings:state?.disable_tomorrows_bookings,
      restricted_booking_dates:state?.restricted_booking_dates,
      note: state.note,
      images: finalImages,
      location: dropdownValue?.name === "International" ? location : state.location,
      schedule_type: scheduleType,
      schedule_data: state.schedule_data,
      valid_till: state.valid_till,
      price: state.price,
      best_seller: state.best_seller,
      description: content,
      deal: state.deal,
      featured: state.featured,
      covid_safe: state.covid_safe,
      opening_soon: state.opening_soon,
      location_city: state.location_city || '',
      location_country: state.location_country,
      flexi_schedule: state.flexi_schedule,
      enable_payment: state.enable_payment,
      revised_price: state.revised_price ? state.revised_price : 0,
      location_type: state.location_type,
      group_size: state.group_size,
      ages: state.ages,
      activity_type: state.activity_type,
      activity_level: state.activity_level,
      itinerary: state.itinerary,
      accomodations: state.accomodations,
      essential_info: state.essential_info,
      faq: state.faq,
      featured_amenities: state.featured_amenities,
      room_amenities: state.room_amenities,
      structured_data:{"data":structureData},
      hotel_resort_facilities: state.hotel_resort_facilities,
      price_list:[
        ...priceList?.adults?.map((elem,index)=>{
          return { "age_group":"adult", "num_people":parseInt(`${index+1}`),"price":elem['adult' + (index + 1)]}
        }),
        ...priceList?.children?.map((elem,index)=>{
          return { "age_group":"child", "num_people":parseInt(`${index+1}`),"price":elem['child' + (index + 1)]}
        }),

        // {"age_group":"adult", "num_people":1, "price": parseInt(priceList?.adults?.adult1)}, {"age_group":"adult", "num_people":2, "price": parseInt(priceList?.adults?.adult2)},
        // {"age_group":"adult", "num_people":3, "price": parseInt(priceList?.adults?.adult3)}, {"age_group":"adult", "num_people":4, "price": parseInt(priceList?.adults?.adult4)},
        // {"age_group":"adult", "num_people":5, "price": parseInt(priceList?.adults?.adult5)}, {"age_group":"adult", "num_people":6, "price": parseInt(priceList?.adults?.adult6)},
        // {"age_group":"adult", "num_people":7, "price": parseInt(priceList?.adults?.adult7)}, {"age_group":"adult", "num_people":8, "price": parseInt(priceList?.adults?.adult8)},
        // {"age_group":"adult", "num_people":9, "price": parseInt(priceList?.adults?.adult9)}, {"age_group":"adult", "num_people":10, "price": parseInt(priceList?.adults?.adult10)},
        // {"age_group":"child", "num_people":1, "price": parseInt(priceList?.children?.child1)}, {"age_group":"child", "num_people":2, "price": parseInt(priceList?.children?.child2)},
        // {"age_group":"child", "num_people":3, "price": parseInt(priceList?.children?.child3)}, {"age_group":"child", "num_people":4, "price": parseInt(priceList?.children?.child4)},
        // {"age_group":"child", "num_people":5, "price": parseInt(priceList?.children?.child5)}, {"age_group":"child", "num_people":6, "price": parseInt(priceList?.children?.child6)},
        // {"age_group":"child", "num_people":7, "price": parseInt(priceList?.children?.child7)}, {"age_group":"child", "num_people":8, "price": parseInt(priceList?.children?.child8)},
        // {"age_group":"child", "num_people":9, "price": parseInt(priceList?.children?.child9)}, {"age_group":"child", "num_people":10, "price": parseInt(priceList?.children?.child10)}
    ]
    };
  
    
    // Check if at least one adult and one child have a valid price
    const hasAdultWithPrice = addNewData.price_list.some(
      item => item.age_group === 'adult' && item.price !== null && item.price >= 0
    );
    
    const hasChildWithPrice = addNewData.price_list.some(
      item => item.age_group === 'child' && item.price !== null && item.price >= 0
    );

    
    const htmltoText = (html) => {
      let text = html;
      text = text.replace(/\n/gi, "");
      text = text.replace(/<style([\s\S]*?)<\/style>/gi, "");
      text = text.replace(/<script([\s\S]*?)<\/script>/gi, "");
      text = text.replace(/<a.*?href="(.*?)[\?\"].*?>(.*?)<\/a.*?>/gi, "");
      text = text.replace(/<\/div>/gi, "");
      text = text.replace(/<\/li>/gi, "");
      text = text.replace(/<li.*?>/gi, "  *  ");
      text = text.replace(/<\/ul>/gi, "");
      text = text.replace(/<\/p>/gi, "");
      text = text.replace(/<br\s*[\/]?>/gi, "");
      text = text.replace(/<[^>]+>/gi, "");
      text = text.replace(/^\s*/gim, "");
      text = text.replace(/ ,/gi, "");
      text = text.replace(/ +/gi, "");
      text = text.replace(/\n+/gi, "");
      text = text.replace('&nbsp;', "");
      return text;
    };
    if (htmltoText(content).replaceAll(' ', '').trim().length === 0) {
      setIscorpAddDesErrorValidation(true);
      focusInput("#desc")
      return;
    }
    else if (dropdownValue?.id === undefined || dropdownValue?.id === null) {
      setIsCorpAddSecnameErrorValidation(true);
  } else if (state.pack_title === "" || state.pack_title === undefined) {
      setIsCorpAddPackTitleEmptyErrorValidation(true);
  } else if (symbolValidation) {
      setSymbolValidation(true);
  } else if (state.pack_title.length > 150) {
      setIsCorpAddPackTitleLengthErrorValidation(true);
  }
  else if (!state.slug || state.slug.length<0) {
    setIsSlug(true);
    focusInput('#package-slug')
}
   else if (imagesWithoutId.length === 0) {
      focusInput("#image-selection");
      setIsCorpAddImgErrorValidation(true)
  } else if (!imageThubnail) {
      setIsCorpAddImgThumbnailErrorValidation(true);
  } else if (state.price === "" || state.price === undefined) {
      setIsCorpAddPointsEmptyErrorValidation(true);
      focusInput("#price")
  } else if (state.price.length > 6) {
      setIsCorpAddPointsLengthErrorValidation(true);
      focusInput("#price")
  }
  else if(Object.values(priceList).every((category) =>
    Object.values(category).every((value) => value === null))){
      enqueueSnackbar("Please fill all the fields of add rate", {
        variant: "error",
    });
    
  }
    else if (priceList?.adults[0]?.adult1?.length > 6) {
      setIsError({error: true, name: "revised_price", msg: REVISED_PRICE_LENGTH})
      focusInput("#price")
    }
    else if(Number(state.price) <= Number(priceList?.adults[0].adult1)) {
      setIsError({ error:true, msg:REVISED_PRICE_ERROR, name: "revised_price" })
      focusInput("#price")
    }
    else if (!hasAdultWithPrice && !hasChildWithPrice) {
      setIsError({error: true, name: "discounted_rate", msg: "Please add atleast one adult and one child rate"})
      focusInput("#discounted_rate")
    }

    // else if (state.brief_description === "" || state.brief_description === undefined) {
    //   setIscorpAddBrigDescEmtyErrorValidation(true)
    //   focusInput("#brief")
    // }
    // else if (state.brief_description.length > 300) {
    //   setIscorpAddBrigDescLengthErrorValidation(true)
    //   focusInput("#brief")
    // }
    // else if ((state.group_size.min == "" || state.group_size.max == "") && state.package_type == "itinerary" ) setIsError({error: true, name: "guest_no", msg: GUEST_EMPTY})
    else if (Number(state.group_size.min) > Number(state.group_size.max) ) {
      setIsError({error: true, name: "guest_no", msg: GUEST_ERROR})
      focusInput("#groupSize")
    }
    else if (dropdownValue?.name === "International" && state?.location_country === "") {
      setIsError({error: true, name: "location_error", msg: COUNTRY_ERROR});
      focusInput("#locationDropdown")
    }
    else if (dropdownValue?.name !== "International" && state?.location_city === "") {
      setIsError({error: true, name: "location_error", msg: CITY_ERROR});
      focusInput("#locationDropdown")
    }
    
    else if (dropdownValue?.name !== "International" && (state.location === undefined || state.location.length === 0)){
      focusInput("#set-pin-location")
      setIscoprAddLocationEmptyErrorvalidation(true)
    } 
    else if ((dropdownValue?.name !== "International" && state.location.length > 300)) setIscoprAddLocationLengthErrorvalidation(true)
    else if ((Object.entries(state.schedule_data).length === 0) && !state.flexi_schedule) {
      setIscorpAddScheduleErrorValidation(true)
      focusInput(state.package_type == "itinerary" ? "#desc" :"#schedule")
    }
    else if (state.location_type == "" && state.package_type == "staybased") {
      setIsError({error: true, name: "location_type", msg: LOCATION_TYPE_EMPTY})
      focusInput("#locationType")
    }
    else if (state.location_type.length > 20 && state.package_type == "staybased") {
      setIsError({error: true, name: "location_type", msg: LOCATION_TYPE_CHAR_LIMIT})
      focusInput("#locationType")
    }
    else if (checkFeaturedAmenitiesLength(state.featured_amenities) && state.package_type == "staybased") {
      setIsError({error: true, name: "featured_amenities", msg: FEATURED_AMENITIES_ERROR})
      focusInput("#amenities")
    }
    else if (state.activity_type == "" && state.package_type == "itinerary") {
      setIsError({error: true, name: "activity_type", msg: ACTIVITY_TYPE_EMPTY})
      focusInput("#itineraryFields")
    }
    else if (state.activity_level == "" && state.package_type == "itinerary") {
      setIsError({error: true, name: "activity_level", msg: ACTIVITY_LEVEL_EMPTY})
      focusInput("#itineraryFields")
    }
    else if (state.ages == "" && state.package_type == "itinerary") {
      setIsError({error: true, name: "ages", msg: AGES_EMPTY})
      focusInput("#itineraryFields")
    }
    
    else if (state.valid_till === "" || state.valid_till === undefined) {
      setIscorpAddValidTillErrorValidation(true)
      focusInput("#validTill")
    }
    else {
      setIsLoading(true);
      dispatch(holidayListingAction.handleAddNewHoliday(addNewData, refreshData, handleError, loader));
    }
  };
  const refreshData = () => {
    setState({
      pack_title: "",
      brief_description: "",
      note: null,
      images: [],
      location: [],
      schedule_type: "",
      schedule_data: {},
      valid_till: "",
      // featured: false,
      price: "",
      best_seller: false,
      location_city: "",
      location_country: "",
      description: "",
    });
    enqueueSnackbar("Package added successfully", {
      variant: "success",
    });
    setIsLoading(false);
    window.location.reload();
  };

  // all options from https://xdsoft.net/jodit/doc/
  const configJoditEditor = {
    readonly: false,
    askBeforePasteHTML: false,
    askBeforePasteFromWord: false,
    // placeholder: "Description...",
    addNewLineOnDBLClick: false,
    controls: {
      font: false,
    },
    height: "500px"
  };

  const setSchedules = (days, nights, scheduleType) => {
    setState((prevstate) => {
      return { ...prevstate, 
        schedule_data: { days: days, nights: nights },
        schedule_type: scheduleType
       };
    });
    setScheduleType(scheduleType);
    setPopupSelect(false);
    setIscorpAddScheduleErrorValidation(false)
  };

  const saveDateData = (date, scheduleType) => {
    setScheduleType(scheduleType);
    // date.forEach(function (arrayItem) {
    //   arrayItem.from = moment(arrayItem.from).format("DD-MM-YYYY");
    //   arrayItem.to = moment(arrayItem.to).format("DD-MM-YYYY");
    // })
    setDateRangeDate(date)
    setState((prevstate) => {
      return { ...prevstate, 
        schedule_data: { selectedDates: date },
        schedule_type: scheduleType
       };
    });

    date.map((item, index) => {
      if(date.length == index + 1 ){
        setState(() => ({
          ...state,
          schedule_data: { selectedDates: date },
          schedule_type: scheduleType,
          "valid_till": moment(item.to, "DD-MM-YYYY").format("yyyy-MM-DD"),
        }));
      }
    })
    setIscorpAddScheduleErrorValidation(false)
  };
  const resData = dateRangeDate && dateRangeDate !== null && dateRangeDate.map(item => `${item.from} - ${item.to}`);
  const setLocation = (address, latitude, longitude, city, state, country) => {
    setState((prevstate) => {
      return {
        ...prevstate,
        location: [
          {
            address: address,
            latitude: latitude,
            longitude: longitude,
            city: city,
            state: state,
            country: country
          },
        ],
        location_country: country,
      };
    });
    setIscoprAddLocationEmptyErrorvalidation(false)
    setIscoprAddLocationLengthErrorvalidation(false)
  };

  const handleAddRate=()=>{
    setAddHandleRate(true)
  }
  const handleFeaturedpackage = (event) => {
    setState({
      ...state,
      [event.target.name]: event.target.checked,
    });
  };
  const handleBsetSeller = (event) => {
    setState({ ...state, [event.target.name]: event.target.checked });
  };

  const dealHandle = (event) => {
    setState({ ...state, [event.target.name]: event.target.checked });
  };
  const noteHandler = (key, value) => {
    setState(() => ({
      ...state,
      [key]: value.target.value,
    }));
  };
  const openingSoonHanle = (event) => {
    setState({ ...state, [event.target.name]: event.target.checked });
    if (event.target.name === event.target.checked) setOpeningSoon(true)
    else {
      setOpeningSoon(false)
    }
  };

  const covidSafeHandle = (event) => {
    setState({ ...state, [event.target.name]: event.target.checked });
  };

  const openingSoonhandler = (event) => {
    if (event.target.checked === false) {
      setState({
        ...state,
        opening_soon: "",
      });
    } else if (state.opening_soon) return event.target.checked
    else { return event.preventDefault(), setOpeningSoon(true) }
  };

  const handleFlexiSchedule = (event) => {
    if(event.target.checked){
      setDateRangeDate("")
    }
    setState({
      ...state,
      [event.target.name]: event.target.checked,
      schedule_data: event.target.checked ? {} : state?.schedule_data,
      schedule_type: event.target.checked ? '' : state?.schedule_type
    });

  };

  const handleEnablePayment = (event) => {
    setState({ ...state, [event.target.name]: event.target.checked });
  };

  const dateChange = (date) => {
    setState({
      ...state,
      opening_soon: (date.format('YYYY-MM-DD')),
    });
    setOpeningSoon(false)
  };

  const handleUpdatePackageImage = (data) => {
    setState({
      ...state,
      images: data,
    });
    setIsCorpAddImgErrorValidation(false)
    setIsCorpAddImgThumbnailErrorValidation(false)
  };
  const handleCloseImageAdd=()=>{
     setLocationSelect(false)
    //  getCroppedFile("")


  }
  const handleCloseImage=()=>{
    setImageSelect(false)
    dispatch(holidayListingAction.handleAllImages([]))
  }


  const openingSoonLabel = () => {
    if (state.opening_soon !== "" && state.opening_soon !== null) return `Opening on ${state.opening_soon}`
    else {
      return "Opening Soon?"
    }
  };
  const saveDateDataBlockDates = (date) => {
    if(date==null){
    
    
        setState({
          ...state,
          restricted_booking_dates:null
         })

    }
 
    else if(date){
    
    
        setState({
          ...state,
          restricted_booking_dates:{
            "selected_dates":date
          }
         })
         

    }
  
       setPopupDateBLock(false)


  };

  const postLocationCityData = (data) => {
    setIsError({error: false, name: "", msg: ""})
    if (dropdownValue?.name === "International") {
      setState({
        ...state,
        location_country: data
      })
    } else {
      setState({
        ...state,
        location_city: data
      })
    }
  };

  useEffect(()=>{
    const datesArray=state?.restricted_booking_dates?.selected_dates
      
         if(datesArray){
          const data=datesArray[0]?datesArray[0]:false
          const data1=datesArray[1]?datesArray[1]:false
          setBlock_date_range(`${data ? `${data.from} to ${data.to}` : ''}${data1 ? `,${data1.from}` : ''}`);
    
        }

  },[state])


  useEffect(()=>{
    dispatch(bookingAction.selectBlockDatesRestrictions(state))

  },[state])



  
  

  return (
    <div>
      {isLoading && <div style={{ marginLeft: 10, marginBottom: -3 }}><LinearProgress /></div>}
      <div className="packageDetails-holder">
        <form onSubmit={newDataSubmithandler}>
          <div className="form-options">
            <div>
              <h2>Adding Holidays</h2>
            </div>
            <div className="form-btns d-flex align-items-center">
              <div style={{}}>
                <FeaturedPackage featured={state.featured} handleFeaturedpackage={handleFeaturedpackage} />
              </div>
              <div
                className="section-dropdown"
                style={{
                  position: "relative",
                  cursor: "pointer",
                  width: "auto",
                }}
              >
                <div>
                  <Button
                    style={{ paddingRight: "32px" }}
                    aria-controls="section-menu"
                    aria-haspopup="true"
                    onClick={handleClickSelect}
                  >
                    {dropdownValue?.name || "Select section"}
                    <img
                      alt="arrow"
                      src={ArrowDown}
                      style={{
                        position: "absolute",
                        right: "12px",
                        top: "12px",
                      }}
                    />
                  </Button>
                  <Menu
                    id="section-menu"
                    anchorEl={select}
                    keepMounted
                    open={Boolean(select)}
                    onClose={() => setSelect(null)}
                  >
                    {filteredDropDownList &&
                      filteredDropDownList.map((item) => {
                        return (
                          <MenuItem
                            onClick={() => handleCloseSelect(item)}
                            key={item.id}
                          >
                            {item.name}
                          </MenuItem>
                        );
                      })}
                  </Menu>
                </div>
              </div>
              <div>
                <button type="submit" disabled={isLoading} className="btn btn-primary btn-save">
                  Save
                </button>
              </div>
            </div>
          </div>
          {isCorpAddSecnameErrorValidation && <p style={{ textAlign: "end", marginRight: "9%", color: "red" }}>{SECTION_NAME}</p>}
          {isFeaturedErrorValidation && <p style={{ textAlign: "end", marginRight: "9%", color: "red" }}>{isFeaturedErrorValidation}</p>}
          <PackTypeButtons fromAdd={true} state={state} setState={setState} label={true}/>
          <div>
            <div className="form-group form-custom">

              <Input
                label=" Listing Title "
                maxLimit={140}
                value={state?.pack_title}
                handleChange={(val) => handleChange("pack_title", val)}
              />
               
           
             
              
              {isCorpAddPackTitleEmptyErrorValidation ? <Error error={PACKAGE_TITLE_EMPTY_ERROR_VALIDATION} /> : ""}
              {isCorpAddPackTitleLengthErrorValidation ? <Error error={PACKAGE_TITLE_LENGTH_ERROR_VALIDATION} /> : ""}
              {symbolValidation?<Error error={symbolErrorMsg}/>:""}
            </div>
            <div className="form-group form-custom" id="package-slug">
              <Input
                label=" Package Slug "
                maxLimit={150}
                value={state?.slug}
                handleChange={(val) => handleChange("slug", val)}
              />
              {isSlug?<Error error={"Please add slug"} /> : ""}
               
           
             
              
              {/* {isCorpAddPackTitleEmptyErrorValidation ? <Error error={PACKAGE_TITLE_EMPTY_ERROR_VALIDATION} /> : ""}
              {isCorpAddPackTitleLengthErrorValidation ? <Error error={PACKAGE_TITLE_LENGTH_ERROR_VALIDATION} /> : ""}
              {symbolValidation?<Error error={symbolErrorMsg}/>:""} */}
            </div>
            <div className="form-group form-custom">
              <Input
                label=" Meta Title"
                maxLimit={80}
                mandatory={false}
                value={state?.meta_title}
                handleChange={(value) =>
                  noteHandler("meta_title", value)
                   }
              />
              </div>
            <div className="form-group form-custom">
           <label>Meta Description `({state?.meta_description?.length}/180)`</label>
            <textarea
                    style={{ height: "98px",resize: "none" }}
                    resize= "none"
                    maxlength="180"
                    type="text"
                    className="form-control"
                    mandatory={false}
                    value={state?.meta_description}
                    onChange={(value) =>
                      noteHandler("meta_description", value)
                       }
                  />
          
            </div>
            {/* <Meta_Input
               length={state?.meta_title != null ? state?.meta_title.trim().length : 0}
                label="Meta Title*"
                maxlength={150}
                value={state?.meta_title}
                handleChange={(val) => meta_title_change("meta_title", val)}
                
              />
               <Meta_Input
               length={state?.meta_description != null ? state?.meta_description.trim().length : 0}
                label="Meta Description*"
                maxlength={250}
                value={state?.meta_description}
                handleChange={(val) => meta_description("meta_description", val)}
                
              /> */}
            
          
            <div style={{ display: "flex", justifyContent: "space-between" }} >
              <div style={{flex: 0.5}} id="image-selection">
                <div className="common-images-box" onClick={() => setImageSelect(true)}>
                  <img
                    alt=""
                    src={imageThubnail ? imageThubnail.image : DefaultImage}
                  />
                  <h6>
                    <span><FaFileUpload /></span>
                    {addImage.length > 0 ? addImage.length : 0}{' images / videos'}
                  </h6>
                  {isCorpAddImgErrorValidation ? <Error error={IMAGE} /> : ""}
                  {isCorpAddImgThumbnailErrorValidation ? <Error error={THUMBNAIL_IMAGE_ERROR} /> : ""}
                </div>
                <div className="form-group form-custom">


                  <div className="package-price" id="price">
                    <div className="form-group form-custom" style={{marginTop:"0px",marginBottom:"0px"}}>
                      <h6>Rs</h6>
                      <Input
                        label="Original Rate"
                        value={state?.price}
                        handleChange={(value) => priceHandler("price", value)}
                        isDivider={true}
                        disableChar={true}
                      />
                      {isCorpAddPointsEmptyErrorValidation ? <Error error={PRICE} /> : ""}
                      {isCorpAddPointsLengthErrorValidation ? (
                        <Error error={PRICE_LENGTH} />
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
               
                  <div className="package-price" id="discounted_rate">
                    <div className="form-group form-custom" style={{marginTop:"0px",marginBottom:"0px",position:"relative"}}>
                    <img src={PlusIcon} alt="addIcon" style={{  cursor: "pointer",
                      position: "absolute",
                      top: "54%",
                      left: "85%",
                      background: "#f7f2f2",
                      padding: "4px",
                      borderRadius: "9px"}}  onClick={handleAddRate}/>
                      <h6>Rs</h6>
                      <Input
                        label="Discounted Rate"
                        value={revisePrice}
                        disabled={true}
                        // handleChange={(value) => priceHandler("revised_price", value)}
                        isDivider={true}
                        disableChar={true}
                      />
                    
                    </div>
                    {isError.error && isError.name == "discounted_rate" ? (
                        <Error error={isError.msg} />
                      ) : (
                        ""
                      )}
                  </div>
                </div>
           

                <div
                  style={{ height: "164px" }}
                  className="form-group form-custom"
                >
                  <div className="row" style={{ alignItems: "flex-end" }}>
                    <label for="" style={{ marginLeft: "17px" }}>Note</label>
                    <p style={{ marginLeft: "17px", fontSize: "12px", fontWeight: "400", lineHeight: "14px", opacity: "0.4", color: "#000000" }}>{state?.note != null ? state?.note.trim().length : 0}/100</p>
                  </div>
                  <textarea
                    style={{ height: "98px",resize: "none" }}
                    resize= "none"
                    maxlength="100"

                    value={
                      state?.note
                    }
                    type="text"
                    className="form-control"
                    onChange={(value) =>
                      noteHandler("note", value)
                    }
                  />
                </div>
         
                <div
                  style={{ height: "110px" }}
                  className="form-group form-custom"
                >
                  <div className="row" style={{ alignItems: "flex-end" }}>
                    <label for="" style={{ marginLeft: "17px" }}>Edenred Product Code </label>
                    <p style={{ marginLeft: "17px", fontSize: "12px", fontWeight: "400", lineHeight: "14px", opacity: "0.4", color: "#000000" }}>{state?.edenred_product_code != null ? state?.edenred_product_code.trim().length : 0}/20</p>
                  </div>
                  <textarea
                    style={{ height: "40px",resize: "none" }}
                    resize= "none"
                    maxlength="20"

                    value={state?.edenred_product_code}
                    type="text"
                    className="form-control"
                    onChange={(value) =>
                      noteHandler("edenred_product_code", value)
                       }
                  />
                </div>
                
                {// Brief Discription Hidden 
                /*
                 <div style={{ flex: 0.5, height: "fit-content", paddingBottom: "20px" }} className="form-group form-custom" id="brief">
                <span style={{color:"red"}}> * </span> <label for="">Brief Description </label>
                  <textarea
                    style={{ height: '145px' }}
                    value={state?.brief_description}
                    type="text"
                    className="form-control"
                    onChange={(value) =>
                      briefDescriptionHandler("brief_description", value)
                    }
                  />
                  {iscorpAddBrigDescEmtyErrorValidation ?
                    <p style={{ color: "red" }}>{BRIEF_DESCRIPTION_EMPTY}</p> :
                    iscorpAddBrigDescLengthErrorValidation ?
                      <p style={{ color: "red" }}>{BRIEF_DESCRIPTION_EMPTY_LENGTH}</p>
                      : ""}
                </div> */}
                {state.package_type == "staybased" && 
                (<div className="form-group form-custom" id="groupSize">
                  <label for="">Guests No’s</label>
                  <MinMaxInput 
                    state={state} 
                    disableChar={true} 
                    label="Guests No."
                    placeholder1="Min"
                    placeholder2="Max"
                    setState={setState}
                    setIsError={setIsError}
                  />
                  {isError.error && isError.name == "guest_no" ? <Error error={isError.msg} /> : ""}
                </div>)}
                <div className="toggle-container">
                  <label for="">Highlighting</label>
                  <div className="featured-amenities">
                    <div className="box">

                      {dropdownValue?.name !== "Deals" &&
                        <div className="">
                          <ToggleButton
                            label="Also a Deal?"
                            name="deal"
                            checkValue={state?.deal}
                            handleToggleChange={dealHandle}
                          />
                        </div>}
                    </div>
                    {dropdownValue?.name === "International" ?
                      <div className="box" >
                        <ToggleButton
                          label={openingSoonLabel()}
                          name="opening_soon"
                          checkValue={state?.opening_soon}
                          handleToggleChange={(event) => openingSoonhandler(event)}
                        />
                        <OpeningSoonCalander
                          open={openingSoon}
                          closeHandle={() => setOpeningSoon(false)}
                          dateChange={dateChange}
                        />
                      </div> : null
                    }
                    <div className="box" >
                      <ToggleButton
                        label="COVID Safe?"
                        name="covid_safe"
                        checkValue={state?.covid_safe}
                        handleToggleChange={covidSafeHandle}
                      />
                    </div>
                    <div className="box">
                      <FormControl component="fieldset">
                        <FormControlLabel
                          value="start"
                          control={
                            <PurpleSwitch
                              checked={state?.best_seller}
                              size="small"
                              color="primary"
                              name="best_seller"
                              onChange={handleBsetSeller}
                            />
                          }
                          label="Bestseller?"
                          labelPlacement="start"
                        />
                      </FormControl>
                    </div>
                  </div>
                </div>
                {state.package_type == "staybased" &&
                (<div className="toggle-container">
                  <ToggleGroup
                    setState={setState}
                    state={state}
                    options={state.hotel_resort_facilities}
                    label="Hotel/ Resort Facilities"
                    optionsKey="hotel_resort_facilities"
                  />
                </div>)}
              </div>
              <div style={{flex: 1}}>
                {dropdownValue?.name !== "International" &&
                  <div
                    className="form-group form-custom"
                    style={{ display: "block", flex: 1, marginLeft: 10 }}
                  >
                 <span style={{color:"red"}}> * </span><label for="" id="set-pin-location">{isGiftVoucher ? "Redeem at" : "Location"}</label>
                    <div className="location-field">
                      <textarea
                        className="form-control"
                        rows="3"
                        cols="40"
                        type="text"
                        value={state?.location[0]?.address}
                        disabled
                      />
                      <div className="pin-icon">
                        <img
                          className="cursor-pointer"
                          src={PinLocation}
                          alt=""
                          onClick={() => setLocationSelect(true)}
                        />
                      </div>
                    </div>
                    {iscoprAddLocationEmptyErrorvalidation ?
                      <p style={{ color: "red" }}>{LOCATION_EMPTY}</p> :
                      iscoprAddLocationLengthErrorvalidation ?
                        <p style={{ color: "red" }}>{LOCATION_EMPTY_LENGTH}</p>
                        : ""}
                    {locationSelect && (
                      <GoogleMapModal
                        edit={isEdit}
                        open={locationSelect}
                        toggleModal={setLocationSelect}
                        handleCloseDone={handleCloseImageAdd}
                        updateLocation={setLocation}
                      />
                    )}
                  </div>
                }
                <SecondLocation currentPackage={state} setCurrentPackage={setState} isInternational={dropdownValue?.name === "International"}/>
                <div
                  style={{ display: "block", position: "relative", marginLeft: "10px" }}
                  className="form-group form-custom"
                  id="locationDropdown"
                >
                 <span style={{color:"red"}}> * </span> <label for="">{CityAndCountryLabel} </label>
                  <Autocomplete
                    options={dropdownValue?.name === "International" ? countryList : getLocationdropDownList}
                    locationCityval={dropdownValue?.name === "International" ? state?.location_country : state?.location_city}
                    postLocationCityData={postLocationCityData}
                  />
                  {isError.error && isError.name == "location_error" ? <Error error={isError.msg} /> : ""}
                </div>
                {state.package_type == "staybased" &&
                (<div className="form-group form-custom" style={{marginLeft: "10px"}} id="locationType">
                  <Input
                    label="Location Type"
                    value={state?.location_type}
                    handleChange={(val) => handleChange("location_type", val)}
                  />
                  {isError.error && isError.name == "location_type" ? <Error error={isError.msg} /> : ""}
                </div>)}
                {state.package_type == "staybased" &&
                (<div
                  // style={{ flex: 0.6, marginLeft: 10, position: "relative", display: `${dropdownValue?.name === "International" ? "none" : ""}` }}
                  style={{ flex: 0.6, marginLeft: 10, position: "relative" }}
                  className="form-group form-custom"
                  id="schedule"
                >
                  <div className="d-flex" style={{ background: '#fff', border: '1px solid #ced4da', borderRadius: '.25rem', padding: '.375rem 0', lineHeight: '1.5', fontWeight: '400', color: '#495057', fontSize: '1rem', marginBottom: 10 }}>
                    <div className="col-md-9" >Flexible dates</div>
                    <div className="col" style={{ textAlign: 'right' }}>
                      <PurpleSwitch
                        checked={
                          state.flexi_schedule
                        }
                        size="small"
                        color="#2196F3"
                        name="flexi_schedule"
                        onChange={handleFlexiSchedule}
                      />
                    </div>
                  </div>
                  {!state.flexi_schedule && <span style={{color:"red"}}> * </span>} <label for="">Schedule</label>
                  <input
                    value={
                      scheduleType === "package" ? scheduleDaysVal(state?.schedule_data?.days) + scheduleNightsVal(state?.schedule_data?.nights) : !state.flexi_schedule ? resData : ''

                    }
                    type="text"
                    className="form-control"
                    disabled={state.flexi_schedule}
                    onChange={(value) =>
                      dateSheduleHandler("schedule_data", value)
                    }
                  />
                  {iscorpAddScheduleErrorValidation && <p style={{ color: "red" }}>{SCHEDULE}</p>}
                  <img
                    src={Edit}
                    style={{ position: "absolute", right: "20px", top: "105px", padding: "0px 10px", background: "#fff" }}
                    onClick={() => !state.flexi_schedule && setPopupSelect(true)}
                  />

                  
                </div>)}
                                    {/* blocked_dates */}
                  
                                    <div
                    style={{ flex: 0.5, marginLeft: 10, position: "relative" }}
                    className="form-group form-custom" id="schedule"
                  >
                    <div className="d-flex" style={{ background: '#fff', border: '1px solid #ced4da', borderRadius: '.25rem', padding: '.375rem 0', lineHeight: '1.5', fontWeight: '400', color: '#495057', fontSize: '1rem', marginBottom: 10 }}>
                      <div className="col-md-9" >Next Day Booking</div>
                      <div className="col" style={{ textAlign: 'right' }}>
                        <PurpleSwitch
                         size="small"
                         checked={state?.disable_tomorrows_bookings}
                          color="#2196F3"
                          name="flexi_schedule"
                          onChange={(event)=>handleBlockTommorow(event)}

                        />
                     
                      </div>
                    </div>
                   
                    <label for="">Block Date Range </label>
                    <input
                      value={block_date_range ? block_date_range:""}
                      disabled={state?.restricted_booking_dates}
                      type="text"
                      className="form-control"
                      id="schedule"
                    />
                  
                    <img
                      src={Edit}
                      style={{ position: "absolute", right: "20px", top: "105px", padding: "0px 10px", }}
                      onClick={() => { setPopupDateBLock(true) }}
                    />
                  </div>

                  {popupDateBlock && (
                  <BlockDatePopup
                    openPopup={popupDateBlock}
                    closeModal={setPopupDateBLock}
                    // updatePopupData={updateDateDataBlockDates}
                    saveDateData={saveDateDataBlockDates}
                    isHolidayListing={true}
                    data={state}
                    popupDateBlock={popupDateBlock}
                    
                  />
                )}
                  {/* blocked_dates */}

                {popupSelect && (
                    <Popup
                      openPopup={popupSelect}
                      closeModal={setPopupSelect}
                      updatePopupData={setSchedules}
                      saveDateData={saveDateData}
                      isHolidayListing={true}
                      data={state}
                    />
                  )}
                <div
                  style={{ flex: 0.5, marginLeft: 10, position: "relative" }}
                  className="form-group form-custom"
                >
                  <div className="d-flex" style={{ background: '#fff', border: '1px solid #ced4da', borderRadius: '.25rem', padding: '.375rem 0', lineHeight: '1.5', fontWeight: '400', color: '#495057', fontSize: '1rem' }}>
                    <div className="col-md-9" >Enable Payment</div>
                    <div className="col" style={{ textAlign: 'right' }}>
                      <PurpleSwitch
                        checked={
                          state.enable_payment
                        }
                        size="small"
                        color="#2196F3"
                        name="enable_payment"
                        onChange={handleEnablePayment}
                      />
                    </div>
                  </div>
                </div>
                <div
                  style={{ flex: 0.6, marginLeft: 10 }}>
                  <div style={{ display: "block" }} className="form-group form-custom" id="validTill">
                  <span style={{color:"red"}}> * </span> <label for="">Valid till</label>
                    <input
                      value={state?.valid_till}
                      type="date"
                      min={new Date().toISOString().split('T')[0]}
                      className="form-control"
                      onChange={(value) =>
                        validTillHandler("valid_till", value)
                      }
                      disabled={state?.schedule_type == "date_range"}
                    />
                    {iscorpAddValidTillErrorValidation &&
                      <p style={{ color: "red" }}>{VALID_TILL}</p>
                    }
                  </div>
                  {state.package_type == "staybased" && 
                  (<div className="toggle-container" id="amenities">
                    <ToggleGroup
                      setState={setState}
                      state={state}
                      options={state.featured_amenities}
                      label="Featured Amenities"
                      optionsKey="featured_amenities"
                      setIsError={setIsError}
                    />
                    {isError.error && isError.name == "featured_amenities" ? <Error error={isError.msg} /> : ""}
                  </div>)}
                  {state.package_type == "staybased" &&
                  (<div className="toggle-container">
                    <ToggleGroup
                      setState={setState}
                      state={state}
                      options={state.room_amenities}
                      label="Room Amenities"
                      optionsKey="room_amenities"
                    />
                  </div>)}
                  {state.package_type == "itinerary" && 
                (<div className="form-group form-custom" id="groupSize">
                 <span style={{color:"red"}}>*</span> <label for="">Group Size</label>
                  <MinMaxInput 
                    state={state} 
                    disableChar={true} 
                    label="Group Size"
                    placeholder1="Min"
                    placeholder2="Max"
                    setState={setState}
                    setIsError={setIsError}
                  />
                  {isError.error && isError.name == "guest_no" ? <Error error={isError.msg} /> : ""}
                </div>)}
                  {state.package_type == "itinerary" &&
                  (<div className="form-group form-custom" id="itineraryFields">
                    <span style={{color:"red"}}>*</span> <label>Activity Type</label>
                    <Dropdown 
                      options={ACTIVITY_OPTIONS}
                      setState={setState}
                      state={state}
                      label="activity_type"
                      value={state?.activity_type}
                      setIsError={setIsError}
                    />
                    {isError.error && isError.name == "activity_type" ? <Error error={isError.msg} /> : ""}
                    <span style={{color:"red"}}>* </span><label className="mt-3">Activity Level</label>
                    <Dropdown 
                      options={ACTIVITY_LEVEL_OPTIONS}
                      setState={setState}
                      state={state}
                      label="activity_level"
                      value={ACTIVITY_LEVEL_VALUE(state?.activity_level)}
                      setIsError={setIsError}
                    />
                    {isError.error && isError.name == "activity_level" ? <Error error={isError.msg} /> : ""}
                    <div style={{marginTop: "10px"}}>
                      <Input
                        label="Ages"
                        value={state?.ages}
                        // disableChar={true}
                        handleChange={(val) => handleChange("ages", val)}
                      />
                      {isError.error && isError.name == "ages" ? <Error error={isError.msg} /> : ""}
                    </div>
                  </div>)}
                </div>
              </div>
            </div>
          </div>
         
       <div className="form-group form-custom mt-3" id="desc">
       
         <Tabs defaultActiveKey="1" >
          
            <TabPane tab={<> <span style={{color:"red"}}>*</span> Description</>} key="1">
              {/* <JoditEditor
                ref={editor}
                value={content}
                config={configJoditEditor}
                tabIndex={1}
                onBlur={(newContent) => {
                  setContent(newContent); 
                  setIscorpAddDesErrorValidation(false)
                }}
                onChange={(newContent) => { }}
              /> */}
              <CkEditor 
                data={content}
                handleChange={(newContent) => {
                  setContent(newContent); 
                  setIscorpAddDesErrorValidation(false)
                }}
              />
            </TabPane>
            {state.package_type == "itinerary" && (<>
            {/* <TabPane tab = {`Itinerary`} key="2">
                <CkEditor 
                  data={state.itinerary?.single_html_format}
                  handleChange={(newContent) => setState({...state, itinerary: {"single_html_format":newContent}})}
                />
            </TabPane> */}
            <TabPane  tab = {`Accomodations`} key="3">
                <CkEditor 
                  data={state.accomodations}
                  handleChange={(newContent) => setState({...state, accomodations: newContent})}
                />
            </TabPane>
            <TabPane tab = {`Essential Info`} key="4">
                <CkEditor 
                  data={state.essential_info}
                  handleChange={(newContent) => setState({...state, essential_info: newContent})}
                />
            </TabPane>
            <TabPane tab = {<> <span style={{color:"red"}}>* </span>Schedule </>} key="5">
              <ScheduleBoxItinerary 
                setPopupSelect={setPopupSelect} 
                state={state}
                isEdit={true}
                />
            </TabPane>
            <TabPane tab = {`FAQ’s`} key="6">
                <CkEditor 
                  data={state.faq}
                  handleChange={(newContent) => setState({...state, faq: newContent})}
                />
            </TabPane>
            </>
            )}
          </Tabs>
          {iscorpAddDesErrorValidation && <p style={{ color: "red" }}>{DESCRIPTION}</p>}
          {isError.error && isError.name == "itinerary" ? <Error error={isError.msg} /> : ""}
          {isError.error && isError.name == "accomodations" ? <Error error={isError.msg} /> : ""}
          {isError.error && isError.name == "essential_info" ? <Error error={isError.msg} /> : ""}
          {iscorpAddScheduleErrorValidation && state.package_type == "itinerary" && <p style={{ color: "red" }}>{SCHEDULE}</p>}
          {isError.error && isError.name == "faq" ? <Error error={isError.msg} /> : ""}
            
          </div>
        </form>
        {state.package_type == "itinerary" && <div className="form-group form-custom mt-3">
          <ItinraryBoxField setState={setState} state={state} />
        </div>
        }
        <div className="form-group form-custom mt-3">
          <StructureData module="holiday"  structureData={structureData} setStructureData={setStructureData} />
        </div>
      </div>
     

      {addHandleRate&&<AddHandleRate 
                 open={addHandleRate}
                 modalClose={() => setAddHandleRate(false)}
                 setPriceList={setPriceList}
                 handleAddPrice={handleAddPrice}
                 priceList={priceList}
                 isAdd={true}
                 
            />}
      {imageSelect && (
        <ImageMultiSelect
          isAddNewEvent={true}
          isUpdateEvent={false}
          title={state?.pack_title}
          city={state?.location[0]?.city || null}
          images={addImage || []}
          open={imageSelect}
          toggleModal={setImageSelect}
          handleCloseDone={handleCloseImage}
          handleUpdatePackageImage={handleUpdatePackageImage}
          moduleType="holidays"
          sectionName={dropdownValue?.name}
        />
      )}
    </div>
  );
}
